<template>
	<div v-loading="loading" style="position: relative">
<!--		<h3>登录</h3>-->
		<div v-if="language === 'zh-CN'" class="switch-type-div" @click="switchLoginType(loginType === 'account' ? 'qrCode' : 'account')">
			<span>
				<el-tag>{{ loginType === 'account' ? '切换微信扫码登录' : '切换账号登录' }}</el-tag>
				<span style="float: right;margin-left: 10px; margin-top: 12px">
					<span v-show="loginType === 'account'">
						<i class="fa fa-qrcode" aria-hidden="true"></i>
					</span>
					<span v-show="loginType === 'qrCode'">
						<i class="fa fa-television" aria-hidden="true"></i>
					</span>
				</span>
			</span>
		</div>

		<div v-if="loginType === 'account'">
			<el-form @keyup.enter.native="submitForm('ruleForm')" :model="loginObj" :rules="formRules" ref="ruleForm">
				<el-form-item prop="username">
					<el-input v-model="loginObj.username" :placeholder="$t('app.account.username.placeholder')"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input v-model="loginObj.password" :placeholder="$t('app.account.password.placeholder')" show-password></el-input>
				</el-form-item>
			</el-form>
			<div class="login-btn">
				<el-button @click="submitForm('ruleForm')" type="primary" style="width: 100%;">{{$t('app.login.button')}}</el-button>
			</div>
		</div>
		<div v-else class="qrCode-div">
			<div class="qrCode-img-div">
				<div class="qrCode-overtime-shade" v-if="qrCode.expire">
					<p>二维码已失效</p>
					<el-button type="primary" @click="loadWxQrCode(null)">刷新二维码</el-button>
				</div>
				<el-image style="width: 250px; height: 250px" :src="qrCode.qrCode"></el-image>
			</div>
			<h3 class="color-text-blue">请使用微信扫描二维码</h3>
			<p>关注「 AMZDataX 」公众号后完成注册 / 登录</p>
		</div>
		<div style="font-size: 13px;margin-top: 10px" v-if="loginType === 'account'">
			<router-link to="/register" class="a-href">{{$t('app.register.name')}}</router-link>
			<router-link to="/resetPwd" class="a-href" style="float: right">{{$t('app.reset_password.name')}}</router-link>
		</div>

		<el-dialog :visible.sync="bindAccountObj.visible" width="550px" top="200px">
			<login-band-wx-sub :oauth2UserId="bindAccountObj.oauth2UserId"></login-band-wx-sub>
		</el-dialog>
	</div>
</template>

<script>
import { api_login_public } from '@/components/api/sign.js'
import { setToken } from '@/components/common/utils/tokenAuth.js';
import LOGIN_BAND_WX_SUB from '@/components/template/sign/loginBandWx';
import { api_getWxQrCode_login, api_qrBack_login } from "@/components/api/oauth2";

export default {
	name: 'loginSub',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_LOGIN'],
	data() {
		return {
			loading: false,
			loginUser: this.LOGINUSER,
			loginObj: {
				username: '',
				password: '',
				code: ''
			},
			formRules: {
				username: [
					{ required: true, message: this.$t('app.account.username.validator.error'), trigger: 'blur' },
				],
				password: [
					{ required: true, message: this.$t('app.account.password.validator.error'), trigger: 'blur' },
				],
			},
			loginType: this.language === 'zh-CN' ? 'qrCode' : 'account', // account账号类型 qrCode微信登录
			qrCode: {
				qrCode: '',
				ticket: null,
				expire_seconds: null,
				expire: false
			},
			timer: null,
			bindAccountObj: {
				visible: false,
				oauth2UserId: null,
			}
		}
	},
	components: {
		'login-band-wx-sub': LOGIN_BAND_WX_SUB
	},
	created() {
		if (this.$data.loginType === 'qrCode'){
			this.$options.methods.loadWxQrCode(this)
		}
	},
	destroyed() {
		clearTimeout(this.$data.timer)
	},
	computed: {
		language() {
			return this.$store.getters.language;
		},
	},
	methods: {
		submitForm: function(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$options.methods.login(this)
				}
			});
		},
		login: function(this_) {
			this_ = this_ || this
			let username = this_.$data.loginObj.username
			let password = this_.$data.loginObj.password
			// 显示遮罩层
			this_.$data.loading = true
			api_login_public(username, password).then(res => {
				// 关闭遮罩
				setToken(res.data.token)
				window.reSetUser(res.data.userInfo, true)
				this_.$router.push('/')
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.$t('app.login.alert.success.title'), 2)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, this_.$t('app.login.alert.error.title')), 4)
			})
		},
		switchLoginType: function(type) {
			this.$data.loginType = type
			if (type === 'qrCode') {
				this.$options.methods.loadWxQrCode(this)
			} else {
				this.$data.qrCode = {}
				clearTimeout(this.$data.timer)
			}
		},
		loadWxQrCode: function(this_) {
			this_ = this_ || this
			if (this_.$data.loading) {
				this_.F_alertMsg('请勿重复生成', 3)
				return
			}
			// 开启遮罩
			this_.$data.loading = true
			api_getWxQrCode_login('login').then(res => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.$data.qrCode = res.data
				// 执行轮询
				this_.$options.methods.checkQrBack(this_, this_.$data.qrCode.ticket, 1, this_.$data.qrCode.expireSeconds)
			}).catch(err => {
				// 关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, "获取登录二维码失败"), 4)
			})
		},
		checkQrBack: function(this_, ticket, num) {
			this_ = this_ || this
			if (num === 90) {// 超出过期时间 跳出轮询
				this_.$set(this_.qrCode, 'expire', true)
				return
			}
			api_qrBack_login(ticket).then(res => {
				// status后端枚举中
				if (res.data.eventStatus === 'created') {// 未扫码状态
					this_.$data.timer = setTimeout(() => {
						this_.$options.methods.checkQrBack(this_, ticket, ++num)
					}, 1000)
				} else{
					this_.$set(this_.qrCode, 'expire', true)
					if (res.data.eventStatus === 'fail') {
						this_.F_alertMsg(this_.F_getErrMSg(err, "登录失败:"), 4)
					} else { // 扫码操作执行
						clearTimeout(this_.$data.timer)
						if (res.data.status === 1) {
							setToken(res.data.token)
							this_.F_LOGIN()
							this_.$router.push('/')
							this_.F_alertMsg('登录成功', 2)
						} else if (res.data.status === 2) {
							this_.$data.bindAccountObj.visible = true
							this_.$data.bindAccountObj.oauth2UserId = res.data.oauth2UserId
						}
					}
				}
			}).catch(err => {
				clearTimeout(this_.$data.timer)
				this_.F_alertMsg(this_.F_getErrMSg(err, "获取扫码状态出现错误"), 4)
			})
		}
	},
}
</script>

<style scoped>
.login-btn {
	margin-top: 60px;
}

.qrCode-div {
	text-align: center;
}

.qrCode-img-div {
	display: inline-block;
	border: 1px solid #E4E7ED;
	position: relative;
}

.qrCode-overtime-shade {
	position: absolute;
	z-index: 1;
	color: #FFFFFF;
	text-align: center;
	padding-top: 30%;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgb(89, 89, 89, 0.7);
}

.switch-type-div {
	text-align: right;
	margin-bottom: 10px;
	font-size: 40px;
	cursor: pointer;
}
</style>
